import React from "react";
import "../../../assets/css/mycart.css";
// import "../../../assets/css/style.css";


const MyCartNote = () => {
    const currentUrl = window.location.origin;

    return (
        <>
            <div className="cart_note">
                <p style={{ color: "red" }}><strong>Bank Cashback & EMI Details Available On Payment Page</strong></p>
                <p>Normally ships in 5-7 working days. </p>
                <p><a href={`${currentUrl}/#/content/terms-of-use`} target="_blank" rel="noopener noreferrer">*T&C Apply.</a></p>
                {/* <p><b><i>No return/exchange </i></b>permissible</p>
                <p><b><i>No cancellation </i></b>permissible</p> */}

            </div>

        </>
    )
}
export default MyCartNote;